import debounce from 'debounce-promise';
import snakecase from 'lodash/snakeCase';

import { get } from 'helpers/api';

export async function search(type, query, page, sort) {
  const { lat, lng, ...q } = query;
  const params = {
    forIndex: true,
    page,
    limit: 6,
    lat,
    lng,
    'q[s]': sort,
  };

  for (const key in q) {
    params[`q[${snakecase(key)}]`] = q[key];
  }

  const results = await get(`/comps/${type}_comps.json`, { params });
  results.comps = results.leaseComps || results.saleComps;

  return results;
}

export const debouncedSearch = debounce(search, 250);
